import { render, staticRenderFns } from "./ParsingAbbrev.vue?vue&type=template&id=48c66348&scoped=true&"
import script from "./ParsingAbbrev.vue?vue&type=script&lang=js&"
export * from "./ParsingAbbrev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c66348",
  null
  
)

export default component.exports